/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { OrderStatusPaginatedResponseItem } from '../../models/order-status-paginated-response-item';

export interface OrderStatusControllerFindAll$Params {

/**
 * Page number
 */
  page?: number;

/**
 * Items per page
 */
  limit?: number;

/**
 * Search by description
 */
  search?: string;
  order_by?: string;
  order_direction?: string;
}

export function orderStatusControllerFindAll(http: HttpClient, rootUrl: string, params?: OrderStatusControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusPaginatedResponseItem;
}>> {
  const rb = new RequestBuilder(rootUrl, orderStatusControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
    rb.query('order_by', params.order_by, {});
    rb.query('order_direction', params.order_direction, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: OrderStatusPaginatedResponseItem;
      }>;
    })
  );
}

orderStatusControllerFindAll.PATH = '/order/status/all';
